export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const TELEGRAM_LINK = "https://t.me/thesuized";
export const DISCORD_LINK = "https://t.me/thesuized";
export const GITHUB_LINK = "https://github.com/Lettable";
export const TWITTER_LINK = "https://twitter.com";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
// Do it clap??
